import { useSelector } from 'react-redux'
import React, { useEffect, useState } from 'react'
import classnames from 'classnames'

import { Loader } from '@progress/kendo-react-indicators'

import {
  Chart,
  ChartArea,
  ChartAxisDefaults,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesItemTooltip,
  ChartTooltip,
  ChartValueAxis,
  ChartValueAxisItem,
} from '@progress/kendo-react-charts'

import api from 'api'

const DisputeChart = () => {
  const codatConnected = useSelector(state => state.appReducer.commerceCodatConnected)
  const companyId = useSelector(state => state.apiResponseReducers.companyId)

  const dayspanSelected = useSelector(state => state.salesReducer.salesOverviewDaySpan)
  const loadingSalesDisputeChartData = useSelector(state => state.salesReducer.loadingSalesDisputeChartData)
  const salesDisputeChartData = useSelector(state => state.salesReducer.salesDisputeChartData)

  const [chartType, setChartType] = useState('line')
  const [formattedChartData, setFormattedChartData] = useState([])

  const seriesStyle = `smooth`
  useEffect(() => {
    if (codatConnected) {
      api.getSalesDisputeChartData(companyId, dayspanSelected)
    }
  }, [dayspanSelected, codatConnected, companyId])

  useEffect(() => {
    if (salesDisputeChartData) {
      const formattedData = salesDisputeChartData.map(data => ({
        ...data,
        timestamp: new Date(data.date),
      }))

      setFormattedChartData(formattedData)
    }
  }, [salesDisputeChartData])

  return (
    <div className="d-flex flex-column k-relative">
      <div
        style={{
          display: 'inline-flex',
          position: 'absolute',
          zIndex: 2,
          bottom: 0,
          alignSelf: 'flex-end',
          padding: '1rem',
        }}
      >
        <span
          className={classnames('button k-icon k-i-chart-column-clustered k-cursor-pointer text-bold text-xxxl', {
            'color-blue': chartType === 'column',
          })}
          onClick={() => setChartType('column')}
        ></span>
        <span
          className={classnames('button k-icon k-i-chart-line k-cursor-pointer text-bold text-xxxl', {
            'color-blue': chartType === 'line',
          })}
          onClick={() => setChartType('line')}
        ></span>
      </div>
      {!codatConnected && (
        <div className="d-flex justify-content-center mb-3">
          <img
            className="img-fluid"
            src={process.env['REACT_APP_BRC_IMAGE_URL'] + '/svg/sales_popup_disputes.svg'}
            alt="disputes chart"
          />
        </div>
      )}
      {codatConnected && (
        <div className="mr-2" width="33.33%">
          {!loadingSalesDisputeChartData && (
            <Chart style={{ height: 300 }}>
              <ChartLegend position="bottom" />
              <ChartTooltip />
              <ChartArea background="rgb(240,244,246)" />

              <ChartAxisDefaults
                line={{
                  color: 'grey',
                }}
                minorGridLines={{
                  visible: false,
                }}
                majorGridLines={{
                  visible: false,
                }}
                minorTicks={{ visible: false }}
                majorTicks={{ visible: false }}
                visible={true}
              />

              <ChartCategoryAxis>
                <ChartCategoryAxisItem baseUnits={'days'} majorGridLines={{ visible: true }} maxDivisions={10} />
              </ChartCategoryAxis>

              <ChartValueAxis>
                <ChartValueAxisItem narrowRange={false} type={'numeric'} />
              </ChartValueAxis>

              <ChartSeries>
                <ChartSeriesItem
                  type={chartType}
                  style={seriesStyle}
                  data={formattedChartData}
                  field="disputes_volume"
                  categoryField="timestamp"
                  color="#D14343"
                  line={{ width: 4 }}
                  markers={{ visible: false }}
                >
                  <ChartSeriesItemTooltip background="#D14343" />
                </ChartSeriesItem>
              </ChartSeries>
            </Chart>
          )}
          {loadingSalesDisputeChartData && (
            <div
              className="d-flex justify-content-center flex-column align-items-center"
              style={{ height: '300px', background: 'rgb(240, 244, 246)' }}
            >
              <Loader type="converging-spinner" />
              <p className="mt-2">Graph Data Loading...</p>
            </div>
          )}
          <div className="mt-2 text-center">
            <p style={{ fontWeight: '700', color: '#25245F' }}>Disputes</p>
          </div>
        </div>
      )}
    </div>
  )
}

export default DisputeChart
